import React from "react";

const ToolsSuspenseFallback = () => (
  <div className="min-h-[40vh] flex items-center justify-center bg-gray-50 text-gray-500">
    <p className="text-sm tracking-wide">Loading tools…</p>
  </div>
);

export default ToolsSuspenseFallback;
